import { LangsRepository } from '../services/langs.repository';
import { AppService } from '../services/app.service';
import { UsersRepository } from '../services/users.repository';
import { AssigneesRepositoryBUT } from '../services/assignees.repository.but';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
var UsersPage = /** @class */ (function () {
    function UsersPage(langsRepository, usersRepository, appService, authService, assigneesRepositoryBUT) {
        this.langsRepository = langsRepository;
        this.usersRepository = usersRepository;
        this.appService = appService;
        this.authService = authService;
        this.assigneesRepositoryBUT = assigneesRepositoryBUT;
        this.langsReady = false;
        this.usersReady = false;
        this.userNewActive = false;
        this.currentUserToEdit = null;
        this.userEditActive = false;
        this.userReplaceActive = false;
        this.currentReplaceUserId = 0;
        this.init();
    }
    UsersPage.prototype.init = function () {
        var _this = this;
        this.langsRepository.ready.subscribe(function (r) { if (r) {
            _this.langsReady = true;
        } });
        this.usersRepository.prepare().then(function () { _this.usersReady = true; });
    };
    Object.defineProperty(UsersPage.prototype, "currentLang", {
        get: function () { return this.langsRepository.current; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UsersPage.prototype, "users", {
        get: function () { return this.usersRepository.users; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UsersPage.prototype, "user", {
        get: function () { return this.authService.user; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UsersPage.prototype, "menuClass", {
        set: function (v) { this.appService.menuClass = v; },
        enumerable: true,
        configurable: true
    });
    /**
     * Mirrors PreparePage logic from CompanyUsersController:
     * Edit is allowed when hasAccessToAdmins OR user is not admin OR editing self.
     * Edit is blocked when !hasAccessToAdmins && user.IsAdmin && user.Id != currentUser.Id
     */
    UsersPage.prototype.canEditUser = function (u) {
        var currentUser = this.user;
        if (!currentUser || !u || u.id == null) {
            return false;
        }
        var hasAccessToAdmins = this.hasAccessToOtherAdmins(currentUser);
        if (!hasAccessToAdmins && u.isAdmin && u.id !== currentUser.id) {
            return false;
        }
        return true;
    };
    /**
     * Mirrors CheckIfCurrentUserHasAccessToOtherAdmins from CompanyUsersController:
     * SuperAdmin -> true; CrmId null -> true; CrmId 1 -> true; else false
     */
    UsersPage.prototype.hasAccessToOtherAdmins = function (currentUser) {
        if (currentUser.isSuperAdmin) {
            return true;
        }
        if (currentUser.crmId == null) {
            return true;
        }
        if (currentUser.crmId === 1) {
            return true;
        }
        return false;
    };
    UsersPage.prototype.delete = function (user) {
        var _this = this;
        if (confirm(this.currentLang.words["sure"])) {
            this.appService.showNetworkstatus("sending data...");
            this.usersRepository.sendDeleteUser(user).subscribe(function (res) {
                if (!res.data) {
                    _this.appService.showError("API error", _this.currentLang.words['delete-admin'], true, res.responseCode);
                }
                else if (res.responseCode === 200) {
                    _this.appService.showNetworkstatus("sent ok");
                    _this.usersRepository.delete(user);
                    _this.assigneesRepositoryBUT.cacheKey = res.settingsCacheToken;
                }
                else {
                    _this.appService.showError("API error", res.error || res.Error, true, res.responseCode);
                }
            }, function (err) {
                var message = _this.appService.getErrorMessage(err);
                _this.appService.showError("HTTP error", _this.currentLang.words["http_error"] + " in users-page delete sendDeleteUser: " + message, true);
            });
        }
    };
    UsersPage.prototype.goToEdit = function (user) {
        this.currentUserToEdit = user;
        this.userEditActive = true;
    };
    UsersPage.prototype.openBackendEdit = function (user) {
        if (!user || !user.id) {
            return;
        }
        var url = new URL("CompanyUsers/Edit", environment.baseFixUrl);
        url.searchParams.set("Id", "" + user.id);
        url.searchParams.set("companyId", "" + user.companyId);
        this.openBackendUrl(url.toString());
    };
    UsersPage.prototype.openBackendCreateUser = function () {
        var url = new URL("CompanyUsers/Edit", environment.baseFixUrl);
        var firstUser = (this.users && this.users.length > 0) ? this.users[0] : null;
        var companyId = Number(firstUser && firstUser.companyId);
        if (companyId > 0) {
            url.searchParams.set("companyId", "" + companyId);
        }
        this.openBackendUrl(url.toString());
    };
    UsersPage.prototype.openBackendUrl = function (url) {
        if (this.appService.isMobile) {
            var browser = new InAppBrowser().create(url, "_system");
            browser.show();
            return;
        }
        window.open(url, "_blank", "noopener,noreferrer");
    };
    return UsersPage;
}());
export { UsersPage };
